var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explore-tile",attrs:{"id":"plus-one-tile"},on:{"click":_vm.interest}},[_c('div',{attrs:{"id":"plus-one-button"}},[_c('h2',[_vm._v(_vm._s(_vm.interestingLabel))]),_c('span',[_vm._v("+ "+_vm._s(_vm.clickNb))])])])}
var staticRenderFns = []

export { render, staticRenderFns }